
export enum ToasterTypes {
  success = "success",
  error = "error",
  info = "info",
  warn = "warn"
}
